var hashtag_default = {
  "fontElementMap": "_0s-Q0",
  "hashtag": "yNjvq"
};
export {
  hashtag_default as default
};
//# sourceMappingURL=hashtag-scss.js.map
